import { SortKey } from '../../pages/carnivore100/carnivore100.util'

export interface C33Column {
  id: string
  // null for columns that carry no sortable value
  key: SortKey | null
  label: string
  // the glossary the list's audience needs; shown on hover
  help?: string
  width: number
  // locked columns are the row's identity: they cannot be hidden, dragged, or
  // displaced from the first two slots, which is also what the pinning assumes
  locked?: boolean
}

export const COLUMNS: C33Column[] = [
  {
    id: 'rank',
    key: 'rank',
    label: '#',
    help: 'Composite rank at publish. Sorting never renumbers it.',
    width: 92,
    locked: true
  },
  { id: 'ticker', key: 'ticker', label: 'Ticker', width: 124, locked: true },
  {
    id: 'score',
    key: 'score',
    label: 'Score',
    help: 'Composite score across all screens, 0-100.',
    width: 84
  },
  { id: 'name', key: 'name', label: 'Name', width: 170 },
  { id: 'sector', key: 'sector', label: 'Sector', width: 150 },
  { id: 'market', key: 'market', label: 'Mkt', help: 'Listing exchange or market.', width: 78 },
  { id: 'price', key: 'price', label: 'Price', width: 96 },
  {
    id: 'marketCap',
    key: 'marketCap' as SortKey,
    label: 'Cap',
    help: 'Market capitalisation at publish.',
    width: 88
  },
  { id: 'dayChangePct', key: 'dayChangePct', label: 'Day', width: 104 },
  { id: 'timeframeChangePct', key: 'timeframeChangePct', label: 'Change', width: 104 },
  { id: 'tech', key: 'tech', label: 'Tech', help: 'Technical score, 0-100.', width: 78 },
  { id: 'fund', key: 'fund', label: 'Fund', help: 'Fundamental score, 0-100.', width: 78 },
  { id: 'mom', key: 'mom', label: 'Mom', help: 'Momentum score, 0-100.', width: 78 },
  {
    id: 'obOs',
    key: 'obOs',
    label: 'OB/OS',
    help: 'One reading per horizon — short (ST), intermediate (IT) and long (LT) term. OB = overbought, OS = oversold, N = neutral.',
    width: 112
  },
  {
    id: 'upStreakDays',
    key: 'upStreakDays',
    label: 'Streak',
    help: 'Consecutive up days.',
    width: 88
  },
  {
    id: 'trendLabel',
    key: 'trendLabel',
    label: 'Trend',
    help: "The name's structural trend classification.",
    width: 152
  }
]

// Columns that read best sorted high-to-low on first click.
export const DESC_FIRST = new Set<string>([
  'price', 'marketCap', 'dayChangePct', 'timeframeChangePct',
  'score', 'tech', 'fund', 'mom', 'obOs', 'upStreakDays'
])

export const COLUMN_BY_ID: Record<string, C33Column> = Object.fromEntries(
  COLUMNS.map(c => [c.id, c])
)

export const LOCKED_IDS = COLUMNS.filter(c => c.locked).map(c => c.id)
